var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 3.33341V13.3334L9.99935 14.6667L5.99935 13.3334L0.666016 14.6667V4.66675M7.99935 7.33342C9.8403 7.33342 11.3327 5.84103 11.3327 4.00008C11.3327 2.15913 9.8403 0.666748 7.99935 0.666748C6.1584 0.666748 4.66602 2.15913 4.66602 4.00008C4.66602 5.84103 6.1584 7.33342 7.99935 7.33342ZM7.99935 7.33342L7.99935 10.6667",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.e2d0eb32.svg";
export { ForwardRef as ReactComponent };